export const getAuthToken = () => {
  if (typeof localStorage === 'undefined') return null;
  const token = localStorage.getItem('auth_token');
  if (!token || token === 'null' || token === 'undefined') return null;
  return token;
};

export const isAuthenticated = () => !!getAuthToken();
